import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateUserPinVerification } from "store/actions/auth";
import { toast } from "react-toastify";
import { useLogout, useCurrentUser } from "utils/hooks";

const useVerifyPinCode = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();
  const [verifying, setVerifying] = useState(false);

  const verifyPinCode = async (pinCode: string) => {
    setVerifying(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            mutation {
              verifyPinCode (
                pinCode: "${pinCode}"
              ) 
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "update_patients",
        },
      });

      const resData = await res.json();

      if (res.status !== 200 && res.status !== 201) {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn(`For security purposes please log in again.`);
          logOut();
        } else {
          toast.error(`Hmm, something went wrong.`);
          throw new Error("Failed!");
        }
      }

      dispatch(updateUserPinVerification(resData.data.verifyPinCode));
      return resData.data.verifyPinCode;
    } catch (error) {
      console.log(error);
    } finally {
      setVerifying(false);
    }
  };

  return {
    verifyPinCode,
    verifying,
  };
};

export default useVerifyPinCode;
